"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _focusUtils = require("./focusUtils");
var useListBox = function useListBox(_ref) {
  var listBoxRef = _ref.listBoxRef,
    onFocusListBox = _ref.onFocusListBox;
  _react["default"].useLayoutEffect(function () {
    function handleFocusListBox(event) {
      onFocusListBox(event);
    }
    var listBox = listBoxRef === null || listBoxRef === void 0 ? void 0 : listBoxRef.current;
    listBox === null || listBox === void 0 || listBox.addEventListener(_focusUtils.FOCUS_LISTBOX, handleFocusListBox);
    return function () {
      listBox === null || listBox === void 0 || listBox.removeEventListener(_focusUtils.FOCUS_LISTBOX, handleFocusListBox);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listBoxRef, listBoxRef === null || listBoxRef === void 0 ? void 0 : listBoxRef.current, onFocusListBox]);
};
var _default = exports["default"] = useListBox;